/** @module csi/gallery/Copy */
define([
	"dojo/_base/declare",
	"csi/action/CopyController",
	"csi/gallery/NewMixin"
], function(declare,CopyController,NewMixin) {

	return declare([CopyController, NewMixin], {
		/**
		 * Call mixin if no other post processing action
		 */
		postProcessSuccess: function() {
			return this.inherited(arguments) || this._newPostProcess();
		}
	});
});